
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.886 4.33c0-.683.554-1.237 1.237-1.237h10.973V4.33H.886z","fill":"#295E60"}}),_c('ellipse',{attrs:{"cx":"16.407","cy":"3.711","rx":"3.725","ry":"3.711","fill":"#295E60"}}),_c('path',{attrs:{"d":"M.059 4.334A1.24 1.24 0 011.3 3.093v3.503a.62.62 0 01-.62.62H.401a.344.344 0 01-.343-.343V4.334z","fill":"#295E60"}}),_c('rect',{attrs:{"x":"2.956","y":"3.505","width":"1.242","height":"3.711","rx":".621","fill":"#295E60"}}),_c('ellipse',{attrs:{"cx":"16.303","cy":"3.814","rx":"2.173","ry":"2.165","fill":"#fff"}})])
          )
        }
      }
    